export enum ColumnTypeEnum {
  DELETE_ACTION,
  LABEL,
  YN,
  STATUS,
  NO_CIA, 
  ITEM,
  OPTION_GROUP
};
